import styled from "styled-components";
import TextLink from "@streeteasy/design-system/deprecated/TextLink";

import { smallScreen } from "../../../../shared/constants/screenSizes";

export const ErrorMessageContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 580px;
  justify-content: center;

  @media screen and (max-width: ${smallScreen}px) {
    height: 100vh;
  }
`;

export const CloseButton = styled(TextLink)`
  margin-top: 20px;
`;
